export const FETCH_RECALL_ALL_TABLE_START = "FETCH_RECALL_ALL_TABLE_START";
export const FETCH_RECALL_ALL_TABLE_SUCCESS = "FETCH_RECALL_ALL_TABLE_SUCCESS";
export const FETCH_RECALL_ALL_TABLE_FAIL = "FETCH_RECALL_ALL_TABLE_FAIL";

export const SET_CHECKBOX = "SET_CHECKBOX";

export const SELECT_ALL_CHECKBOX = "SELECT_ALL_CHECKBOX";
